export default __webpack_public_path__ + "static/media/redo.5493ccc0.svg";